/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Slider from "react-slick";
import { useTranslation } from 'react-i18next';
import { DotsLine, NearbySvg, Next, Prev } from '../../common/svg/AllSvg';
import { useNavigate, useParams } from 'react-router-dom';
import SecondaryBtn from '../../common/form/SecondaryBtn';
import { useDeviceType } from '../../../shared/utils/useDeviceType';

const NearByPlaces = () => {
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const [data, setData] = useState<any[]>([])
	const [select, setSelect] = useState<any>("")
	const [hover, setHover] = useState<any>("")
	const [placesData, setPlacesData] = useState<any[]>([])
	const [place, setPlace] = useState(0);
	const { t } = useTranslation('common');
	const arrowRef: any = useRef(null);
	const params = useParams();
	const navigate = useNavigate();
	const isMobile = useDeviceType();

	const colors: any = {
		"transportation": "bg-[#B75A5A]",
		"sports": "bg-[#5AB788]",
		"residental": "bg-[#B7B45A]",
		"recreation": "bg-[#5A5BB7]",
		"private-offices": "bg-[#D600C8]",
		"nature": "bg-[#00D62E]",
		"institutional": "bg-[#BDD600]",
		"hotels": "bg-[#566EE4]",
		"commercial": "bg-[#0097D6]",
		"government-offices": "bg-[#56CAE4]",
		"religious": "bg-[#E4AE56]",
		"health": "bg-[#E45656]"
	}

	const settings = {
		dots: false,
		variableWidth: true,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					arrows: false,
					variableWidth: false,
					infinite: false,
				}
			},
		]
	}

	useEffect(() => {
		if (!!stationDetailData && stationDetailData?.nearby_places?.length > 0) {
			let arr: any[] = [];
			for (let i = 0; i < stationDetailData?.nearby_places?.length; i++) {
				const el = stationDetailData?.nearby_places?.[i];
				let exist: any = arr?.filter((item: any) => item?.id === el?.types_of_place?.group?.id)
				if (exist?.length === 0) {
					arr.push(el?.types_of_place?.group)
				}
			}
			setSelect(arr[0]?.id)
			setData(arr)
		}
	}, [stationDetailData]);

	useEffect(() => {
		if (stationDetailData?.nearby_places?.length > 0 && !!select) {
			let arr: any[] = [];
			for (var i = 0; i < stationDetailData?.nearby_places?.length; i++) {
				if (stationDetailData?.nearby_places?.[i]?.types_of_place?.group?.id === select) {
					arr.push(stationDetailData?.nearby_places[i])
				}
			}
			setPlacesData(arr)
		}
	}, [select]);

	const beforeChange = (oldIndex: any, newIndex: any) => {
		setPlace(newIndex)
	};

	return (
		<>
			<div className='overflow-hidden w-full mt-[30px] xlx:mt-[40px] h-full' id="nearby_places">
				<div className='container w-full h-full' id="nearby_places">
					<div className="flex items-center gap-[9px]">
						<NearbySvg className="w-[25px] h-[25px] fill-[#047AAC]" />
						<h5 className='font-bold text-[#047AAC] uppercase'>{t('passenger.station_detail.nearby_places')}</h5>
					</div>

					<div className='flex items-center gap-[10px] flex-wrap mt-[25px]'>
						{Array.isArray(data) && data?.map((item: any, index: number) => (
							<button className={`${select === item?.id ? "border border-secBlue text-secBlue bg-white focus:shadow-[0_0_0_2px_#0097d65e] hover:shadow-[0_0_0_2px_#0097d65e]" : "border border-[#B3B3B3] text-blackDull dark:text-textBlackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[20px] flex items-center justify-center h-[35px] xlx:h-[37px] px-[15px] ${!!!hover && "relative z-[1]"}`} key={index} onClick={() => setSelect(item?.id)}>
								<h6 className='font-semibold'>{item?.name}</h6>
							</button>
						))}
					</div>

					<div className="w-full overflow-hidden py-[20px]">
						<DotsLine />
					</div>

					<Slider className='h-full flex w-[100vw] mt-[-175px]' ref={arrowRef} beforeChange={beforeChange} {...settings}>
						{Array.isArray(placesData) && placesData?.map((item: any, index: number) => (
							<div className={`pr-[10px] lg:pr-[15px] xlx:pr-[20px] h-[550px] ${(place === index) ? `${(hover === item?.name && !isMobile) && "pl-[35px]"}` : ""}`} key={index}>
								<div className='flex items-center h-full'>
									<button className={`${hover === item?.name ? "shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] dark:shadow-[0px_4px_6px_-4px_#ffffff1f,0px_8px_8px_-4px_#ffffff14] border border-transparent h-[300px] relative z-[1] bg-white dark:bg-bgDarkDull near-by-place" : "border border-[#EDEDED] dark:border-[#454545] h-[180px]"} rounded-[20px] w-[325px] near-by-place-card cursor-default`} onMouseEnter={() => setHover(item?.name)} onMouseLeave={() => setHover("")} onFocus={() => !isMobile && setHover(item?.name)} onClick={() => setHover(item?.name)} onBlur={() => setHover(null)}>
										<div className={`h-[48px] px-[21px] flex items-center w-full rounded-t-[20px] ${hover === item?.name ? `${colors[item?.types_of_place?.class_name]} bg-opacity-[0.1]` : "bg-[#F4F4F4] dark:bg-[#46495370] bg-opacity-[0.65]"} relative`}>
											<p className='uppercase font-semibold text-blackDull dark:text-textBlackDull max-w-[228px] text-xs leading-snug text-left'>{item?.types_of_place?.name}</p>

											<div className='absolute right-[25px] top-[28px]'>
												<div className={`${hover === item?.name ? `${colors[item?.types_of_place?.class_name]}` : "bg-white shadow-[0px_2px_4px_-2px_rgba(24,39,75,0.12),0px_4px_4px_-2px_rgba(24,39,75,0.08)]"} rounded-[10px] min-w-[40px] h-[40px] flex items-center justify-center`}>
													<img src={item?.types_of_place?.image?.file} alt={item?.name} className={`${hover === item?.name ? "gates-icon" : ""}`} />
												</div>
											</div>
										</div>

										<div className={`flex flex-col justify-between h-[calc(100%-47px)] px-[23px] ${hover === item?.name ? "py-[25px]" : "pt-[37px] pb-[25px]"}`}>
											<div className='flex flex-col h-full'>
												<h5 className='text-blackDark dark:text-textBlackDark font-bold text-left'>{item?.name}</h5>


												<div className={`flex flex-col ${hover === item?.name ? "opacity-[1]" : "opacity-0 hidden"}`}>
													<div className='border-b border-primary border-opacity-[0.2] w-full my-[19px]'></div>

													<div className='flex gap-[25px] w-full'>
														<div className='flex flex-col gap-[4px] w-[50%]'>
															<p className='text-primary font-semibold text-left'>{t("passenger.station_detail.near_gate")}</p>
															{item?.nearest_gate?.length > 0 ? <div className="flex items-center justify-start gap-[4px] flex-wrap">
																{(Array.isArray(item?.nearest_gate) && item?.nearest_gate?.map((i: any, idx: number) =>
																	<h5 className="text-blackDull dark:text-textBlackDull font-bold" key={idx}>
																		{i?.gate_name + `${item?.nearest_gate?.length !== idx + 1 ? ', ' : ' '}`}
																	</h5>
																))}
															</div> : <h5 className="text-blackDull dark:text-textBlackDull font-bold text-left">-</h5>}
														</div>

														<div className='flex flex-col gap-[4px] w-[50%]'>
															<p className='text-primary font-semibold text-left'>{t("passenger.station_detail.distance_gate")}</p>
															<h5 className='text-blackDull dark:text-textBlackDull font-bold text-left'>{!!item?.distance_from_metro ? item?.distance_from_metro : "0"} {t("passenger.home.fare.detail.km")}</h5>
														</div>
													</div>
												</div>
											</div>

											<div className={`${hover === item?.name ? "opacity-[1]" : "opacity-0 hidden"}`}>
												<SecondaryBtn css="!rounded-[6px] font-bold w-full uppercase" title={t("passenger.home.banner.trip_planner.form.plan_journey")} onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/map?to=${stationDetailData?.code}&toName=${stationDetailData?.name}&toType=station&date=${new Date()}&journey=one_way`) : navigate(`/map?to=${stationDetailData?.code}&toName=${stationDetailData?.name}&toType=station&date=${new Date()}&journey=one_way`); }} />
											</div>
										</div>
									</button>
								</div>
							</div>
						))}
					</Slider>

					<div className={`flex items-center gap-[20px] justify-end w-full pb-[2px] mt-[-130px] ${!!!hover && "relative z-[1]"}`}>
						<div className='flex items-center gap-[8px]'>
							<button aria-label={t("aria_label.prev_arr")}
								title={t("aria_label.prev")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#059DB25e] dark:hover:shadow-[0_0_0_2px_#059DB25e]" onClick={() => arrowRef.current.slickPrev()}>
								<Prev className="!w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] fill-primary" />
							</button>
							<button aria-label={t("aria_label.next_arr")}
								title={t("aria_label.next")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#059DB25e] dark:hover:shadow-[0_0_0_2px_#059DB25e]" onClick={() => arrowRef.current.slickNext()}>
								<Next className="!w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] fill-primary" />
							</button>
						</div>

						<button className="h-[35px] xlx:h-[39px] w-fit flex items-center justify-center rounded-[10px] bg-[#d1d1d133] border border-[#AFAFAF33] px-[24px] xlx:px-[30px] uppercase text-primary focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#059DB25e] dark:hover:shadow-[0_0_0_2px_#059DB25e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/nearby-places/${params?.code}`) : navigate(`/nearby-places/${params?.code}`)}><h6 className='font-extrabold'>{t("passenger.station_detail.view_all")}</h6></button>
					</div>
				</div>
			</div>
		</>
	);
};

export default NearByPlaces;